import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { tryNow } from "../../utils";

export const ProductBanner = (props) => {
  const { t } = useTranslation();
  const { title, subTitle, bannerImg, bannerBG, hasButton, docLink } = props;
  return (
    <div className="gateway-integration-banner">
      <div className="inner">
        <div className="banner-content">
          <h1 className="slogn">{t(title)}</h1>
          <div className="descrption">{t(subTitle)}</div>
          {hasButton && (
            <div className="button-warp">
              <div className="button button-filled" onClick={tryNow}>
                {t("common.button.try-now")}
              </div>
              <a
                className="button button-line"
                href={docLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ visibility: docLink ? "visible" : "hidden" }}
              >
                {t("common.button.linkDoc")}
              </a>
            </div>
          )}
        </div>
        <div className="banner-img">
          <img src={bannerImg?.src} alt={bannerImg?.alt} />
        </div>
      </div>
      <div className="bg-img">
        <img src={bannerBG?.src} alt={bannerBG?.alt} />
      </div>
    </div>
  );
};
